import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RestRoutes } from '../_config/rest-routes.config';
import { ContactGroup } from '../_models/contact-group.model';
import { SearchFilterDTO } from '../_models/search-filter-dto.model';
import { Contact } from '../_models/contact.model';

const API_URL = environment.urlPages;

@Injectable({
  providedIn: 'root',
})

export class ContactGroupService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-Type': 'application/json'
      }
    )
  };
  constructor(private http: HttpClient) { }

  // getSHPaged(filter: SearchFilterDTO): Observable<ContactGroup[]> {
  //   let urlGetSHPaged: string = `${environment.urlWS}${RestRoutes.CONTACTGROUP}`;
  //   return this.http.get<ContactGroup[]>(urlGetSHPaged, { params: filter as any, ...this.httpOptions });
  // }
  getContactGroup(contactGroupId: string): Observable<ContactGroup> {
    let urlGetContactsByContactGroupId: string = `${environment.urlWS}${RestRoutes.CONTACTGROUP}/${contactGroupId}`;
    return this.http.get<ContactGroup>(urlGetContactsByContactGroupId, this.httpOptions);
  }

  getContactsByContactGroupId(contactGroupId: string): Observable<Contact[]> {
    let urlGetContactsByContactGroupId: string = `${environment.urlWS}${RestRoutes.CONTACTGROUP}/${contactGroupId}/Contacts`;
    return this.http.get<Contact[]>(urlGetContactsByContactGroupId, this.httpOptions);
  }

  getContactGroupByContactGroupId(contactGroupId: string): Observable<ContactGroup[]> {
    let urlGetContactGroupByContactGroupId: string = `${environment.urlWS}${RestRoutes.CONTACTGROUP}/${contactGroupId}`;
    return this.http.get<ContactGroup[]>(urlGetContactGroupByContactGroupId, this.httpOptions);
  }

  addUpdate(params: ContactGroup): Observable<ContactGroup[]> {
    let urlAddUpdate: string = `${environment.urlWS}${RestRoutes.CONTACTGROUP}`;
    return this.http.put<ContactGroup[]>(urlAddUpdate, params, this.httpOptions);
  }

}